import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { showSnackBar } from "../../utils/commonServices";
import { createGuestLogApi, getGuestEventDetailsApi, registerGuestApi } from "../../services/api";
import { setGuestReviewState } from "../../redux/guestSlice";
import { setTheme } from "../../redux/customThemeSlice";



export default ()=> {
 
  const dispatch = useDispatch();
  const commonReducer = useSelector(state=> state.root.commonReducer)
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const code = query.get('c')
  const guestReducer = useSelector(state=> state.guestReducer)


  // const getEventGuestPageDetails = (payload, callback ) => {
  //   guestEventDetails({collab_code: payload}) 
  //   .then((response) => {
  //     dispatch(
  //       updateState({
  //           guest_event_detail: response?.data?.data
  //       })
  //     );
  //     if(response?.data?.http_code === 200){
  //       if(Array.isArray(response?.data?.data?.theme)){
  //         if(response?.data?.data?.theme?.length > 0){
  //           dispatch(setTheme({primary:  response?.data?.data?.theme?.primary_colour, secondary: response?.data?.data?.theme?.secondary_colour, brand_logo: response?.data?.data?.theme?.url, brand_logo_download_url: response?.data?.data?.theme?.download_url}))
  //         }
  //       }else if(Object.keys(response?.data?.data?.theme)?.length > 0){
  //           dispatch(setTheme({primary:  response?.data?.data?.theme?.primary_colour, secondary: response?.data?.data?.theme?.secondary_colour, brand_logo: response?.data?.data?.theme?.url, brand_logo_download_url: response?.data?.data?.theme?.download_url}))
  //          } else {
  //           dispatch(resetTheme())
  //          }
        
  //       callback &&  callback()
  //  }else {
  //      dispatch(setSnackbar({type:'error', flag:true, message: 'some error occured'}))
  //  }
  //   })
  //   .catch((error) => {
  //    if(error) {
  //     const errorObject = error?.response?.data;
  //     showSnackBar(dispatch, errorObject);
  //   }
  //   });
  //   }

    const registerGuestUser = (payload, callback ) => {
      dispatch(setGuestReviewState({is_loading: true}))
      registerGuestApi(payload) 
      .then((response) => {
        if(response?.data?.http_code === 200){
          // console.log(response.data.data.guest_reviewer_id)
          getGuestEventDetails({slug:code, guest_reviewer_id: response?.data?.data?.guest_reviewer_id }, callback)
          dispatch(setGuestReviewState({guest_reviewer_id: response.data.data.guest_reviewer_id}))
        //  callback && callback()
          // getGuestEventDetails({slug: code, guest_reviewer_id: 1})
       }
      })
      .catch((error) => {
       if(error) {
        const errorObject = error?.response?.data;
        showSnackBar(dispatch, errorObject);
        dispatch(setGuestReviewState({is_loading: false}))
      }
      });
      }


      const getGuestEventDetails = (payload, callback ) => {
        getGuestEventDetailsApi(payload) 
        .then((response) => {
          if(response?.data?.http_code === 200){
            console.log(response.data)
            callback && callback()
            dispatch(setGuestReviewState({is_loading: false, event_details: response?.data?.data , logs: response?.data?.data?.logs}))
            dispatch(setTheme({primary:  response?.data?.data?.theme?.primary_colour, secondary: response?.data?.data?.theme?.secondary_colour, brand_logo: response?.data?.data?.theme?.url, brand_logo_download_url: response?.data?.data?.theme?.download_url}))
        //  dispatch(setGuestReviewState({event_details: , logs: , theme:}))
          }
        })
        .catch((error) => {
         if(error) {
          const errorObject = error?.response?.data;
          showSnackBar(dispatch, errorObject);
          dispatch(setGuestReviewState({is_loading: false}))
        }
        });
      }

      const createGuestUserLog = (payload, callback ) => {
        dispatch(setGuestReviewState({create_log_loading: true}))
        createGuestLogApi(payload) 
        .then((response) => {
          dispatch(setGuestReviewState({create_log_loading: false}))
          if(response?.data?.http_code === 200){
            console.log(response.data)
            getGuestEventDetails({slug:code, guest_reviewer_id: guestReducer?.guest_reviewer_id })
            callback && callback()
           
         }
        })
        .catch((error) => {
         if(error) {
          const errorObject = error?.response?.data;
          showSnackBar(dispatch, errorObject);
          dispatch(setGuestReviewState({create_log_loading: false}))
        }
        });
      }
    

  return { registerGuestUser, createGuestUserLog};
}